import React, { useContext, useRef } from 'react'
import { styled } from 'linaria/react'
import { theme } from '../../Theme'
import { cx } from 'linaria'
import { useIntl } from '@jetshop/intl'
import FilterTag from '../../Core/Common/FilterTag'
import { DIGIFI_FILTER_FIELD_NAMES, DIGIFI_SORT_VALUES } from '../../DigifiSearch/constants'
import { SiteContext } from '../../Global/SiteContext'

const FILTER_CONTAINER_HEIGHT_MOBILE = '2.8rem'

const FilterTagsWrapper = styled.ul`
   background-color: ${theme.colors.white};
   padding-left: 1rem;
   padding-right: 1rem;
   padding-top: 0rem;
   padding-bottom: 0.5rem;
   list-style-type: none;
   gap: 0.5rem;
   ${theme.above.md} {
      padding-left: 0rem;
   }

   ${theme.above.lg} {
      flex-wrap: wrap;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      /* min-height: 73px; */
      margin-left: 2rem;
   }

   ${theme.above.xl} {
      padding-left: 2rem;
   }

   &.filters-tags-container {
      align-items: center;
      &::-webkit-scrollbar {
         width: 12px; /* Width of the vertical scrollbar */
         height: 12px; /* Height of the horizontal scrollbar */
      }
      ${theme.below.lg} {
         /* height: ${FILTER_CONTAINER_HEIGHT_MOBILE}; */
      }
   }

   &.hide-fade.filters-tags-container::after {
      opacity: 0;
      transition: opacity 0.12s ease-in-out;
   }

   &.filters-tags-container::after {
      ${theme.below.lg} {
         pointer-events: none; /* ignore clicks */
         content: '';
         position: absolute;
         height: calc(${FILTER_CONTAINER_HEIGHT_MOBILE} - 12px);
         left: 0;
         width: 100%;
         background: -moz-linear-gradient(
            90deg,
            rgba(248, 249, 250, 0) 0%,
            rgba(248, 249, 250, 0) 90%,
            rgb(248, 249, 250, 1) 100%
         );
         background: -webkit-linear-gradient(
            90deg,
            rgba(248, 249, 250, 0) 0%,
            rgba(248, 249, 250, 0) 90%,
            rgb(248, 249, 250, 1) 100%
         );
         background: linear-gradient(
            90deg,
            rgba(248, 249, 250, 0) 0%,
            rgba(248, 249, 250, 0) 90%,
            rgb(248, 249, 250, 1) 100%
         );
         filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff",endColorstr="#ffffff",GradientType=1);
      }
   }
`

const FilterTags = ({
   filters = [],
   facets = {},
   updateFilters,
   visibleFilterTagsByFieldName = [],
   onClearFilters,
}) => {
   const t = useIntl();
   const containerRef = useRef(null);
   const { showVat } = useContext(SiteContext)

   const maxFilterPriceLimit = showVat ? facets?.priceFacets?.defaultPriceIncVat?.max : facets?.priceFacets?.defaultPriceExVat?.max;
   const minFilterPriceLimit = showVat ? facets?.priceFacets?.defaultPriceIncVat?.min : facets?.priceFacets?.defaultPriceExVat?.min;
   
   const currentMaxPrice = showVat ? facets?.priceFacets?.priceIncVat?.max : facets?.priceFacets?.priceExVat?.max;
   const currentMinPrice = showVat ? facets?.priceFacets?.priceIncVat?.min : facets?.priceFacets?.priceExVat?.min;

   const handleScroll = e => {
      const scrollableDistance = e.target.scrollWidth - e.target.clientWidth;
      const currentScrollPosition = e.target.scrollLeft;
      const isAtEnd = currentScrollPosition >= scrollableDistance;

      if (isAtEnd) {
         containerRef.current?.classList.add('hide-fade');
      } else {
         containerRef.current?.classList.remove('hide-fade');
      }
   };

   const clearFilters = () => {
      onClearFilters?.();
   };

   const enhanceFilterValue = value => {
      if (value === DIGIFI_FILTER_FIELD_NAMES.PREBOOK) {
         return t('prebook');
      }
      if (value === DIGIFI_SORT_VALUES.PRICE_ASC) {
         return t('Price-low-to-high');
      }
      if (value === DIGIFI_SORT_VALUES.PRICE_DESC) {
         return t('Price-high-to-low'); 
      }
      return value;
   };

   const clearableFilters = filters?.filter(filter =>
      visibleFilterTagsByFieldName?.includes(filter?.fieldName)
   );

   if (clearableFilters?.length === 0) {
      return null;
   }

   return (
      <FilterTagsWrapper
         ref={containerRef}
         className={cx(
            'filters-tags-container overflow-auto',
            'd-flex'
         )}
         onScroll={handleScroll}
      >
         {clearableFilters?.length > 0 && (
            <li key={'clear-refinements'}>
               <FilterTag
                  value={t('clear all filters')}
                  isClearTag={true}
                  onClick={clearFilters}
               />
            </li>
         )}
         {clearableFilters?.map(filter => {
            if (filter?.fieldName === DIGIFI_FILTER_FIELD_NAMES.BRAND) {
               const brandValues = Array.isArray(filter?.value) ? filter.value : [filter.value];
               return brandValues.map(brandValue => (
                  <li key={`${filter?.fieldName}-${brandValue}`}>
                     <FilterTag
                        value={enhanceFilterValue(brandValue)}
                        onClick={() =>
                           updateFilters?.([{
                              fieldName: filter?.fieldName,
                              value: brandValue,
                           }])
                        }
                     />
                  </li>
               ));
            }
            if (filter?.fieldName === DIGIFI_FILTER_FIELD_NAMES.PRICE) {
               return (
                  <li key={`${filter?.value[0]}-${filter?.value[1]}`}>
                     <FilterTag
                        value={`${filter?.value[0] < minFilterPriceLimit ? currentMinPrice : filter?.value[0]} - ${filter?.value[1] > maxFilterPriceLimit ? currentMaxPrice : filter?.value[1]} kr`}
                        onClick={() =>
                           updateFilters?.([{
                              fieldName: filter?.fieldName,
                              value: null,
                           }])
                        }
                     />
                  </li>
               );
            }
            if (filter?.fieldName === DIGIFI_FILTER_FIELD_NAMES.PREBOOK) {
               return (
                  <li key={`${filter?.fieldName}-${filter?.value}`}>
                     <FilterTag
                        value={enhanceFilterValue(filter?.fieldName)}
                        onClick={() =>
                           updateFilters?.([{
                              fieldName: filter?.fieldName,
                              value: null,
                           }])
                        }
                     />
                  </li>
               );
            }
            if (filter?.fieldName === DIGIFI_FILTER_FIELD_NAMES.SORT_BY) {
               return (
                  <li key={`${filter?.fieldName}-${filter?.value}`}>
                     <FilterTag
                        value={enhanceFilterValue(filter?.value)}
                        onClick={() =>
                           updateFilters?.([{
                              fieldName: filter?.fieldName,
                              value: null,
                           }])
                        }
                     />
                  </li>
               );
            }
            return null;
         })}
      </FilterTagsWrapper>
   );
};

export default FilterTags;

